import {
    detailCta,
    type DetailCtaVariant,
} from '~/ui-rocco/pages/detail-shared/detail-cta';

/**
 * The drawer's CTA: the page's own button at the ramp's L step, run the width
 * of the drawer.
 *
 * Not the shared PILL — that is the mobile frame's deliberate 50px/14px pill,
 * and these sit a few hundred pixels from the page's own 52px cluster, where
 * the difference reads as two button systems on one screen. Only the width
 * differs; height, corner and label size come from the step.
 */
export const DRAWER_CTA = (variant: DetailCtaVariant) =>
    detailCta(variant, 'w-full');
